(function(){
  var selector='.visual-category,.trust-item,.hp-products .section-head,.hp-product-card,.spark-mushroom-card,.pet-home-copy,.pet-home-media,.lifestyle-section,.newsletter,.spark-story,.product-card';
  function init(){
    if(!document.body)return;
    var items=Array.prototype.slice.call(document.querySelectorAll(selector));
    if(!items.length)return;
    document.body.classList.add('spark-motion-ready');
    items.forEach(function(el,index){el.classList.add('spark-motion');el.style.setProperty('--spark-delay',((index%4)*65)+'ms')});
    function reveal(el){el.classList.add('spark-in-view')}
    if(!('IntersectionObserver' in window)){items.forEach(reveal);return}
    var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){reveal(entry.target);observer.unobserve(entry.target)}})},{rootMargin:'0px 0px -6% 0px',threshold:.05});
    items.forEach(function(el){observer.observe(el)});
    setTimeout(function(){items.forEach(reveal)},1800);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();